const SIGNATURE_REGEXP = /^[a-zA-Z\s]*$/;

const isSignatureValid = (signatureValue: string) => {
  return signatureValue.trim().length > 0 && Boolean(SIGNATURE_REGEXP.exec(signatureValue));
};

export default isSignatureValid;
